import { FC } from 'react';
import Icon from '../../assets/images/accept.png';
import history from '../../helpers/history';

const ConfirmEmailSuccess: FC = () => {
  const onClickHandler = () => history.push('/');

  return (
    <div className='text-center col-lg-8 offset-lg-2 mt-10'>
      <img src={Icon} alt='Email Notification' width='80px' />
      <h3 className='mt-2 mb-2'>Good Job!</h3>
      <p> You have successfully confirmed your email address. Please proceed to login</p>
      <button className='btn btn-bg me-2 btn-primary mt-2 fs-7' onClick={onClickHandler}>
        Proceed to Login
      </button>
    </div>
  );
};

export default ConfirmEmailSuccess;
